/* Keep theme variant changes on media that were allowed by the server-side filter. */
(function () {
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !event.target || !event.target.id) return;
    var gallery = Array.from(document.querySelectorAll('product-media')).find(function (element) {
      return element.getAttribute('form-id') === event.target.id;
    });
    if (!gallery) return;
    var source = gallery.querySelector('.hh-visible-media-data');
    if (!source) return;
    var media;
    try { media = JSON.parse(source.textContent); } catch (error) { return; }
    if (!media.length) return;
    var selected = variant.featured_media && media.find(function (item) {
      return String(item.id) === String(variant.featured_media.id);
    });
    if (selected) return;
    var fallback = media[0];
    event.detail.variant = Object.assign({}, variant, {
      featured_media: fallback,
      featured_image: fallback.preview_image || null
    });
  }, true);
})();
